module.exports = __webpack_public_path__ + "img/pay-img.a8ace923.jpg";